import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext.jsx';
import Logo   from '../../components/common/Logo.jsx';
import Input  from '../../components/common/Input.jsx';
import Button from '../../components/common/Button.jsx';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate     = useNavigate();
  const [form, setForm]     = useState({ name: '', email: '', password: '', confirm: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name || form.name.length < 2)   e.name     = 'Nom requis (min 2 caractères)';
    if (!form.email)                            e.email    = 'Email requis';
    if (form.password.length < 8)              e.password = 'Min 8 caractères avec majuscule, minuscule et chiffre';
    if (form.password !== form.confirm)        e.confirm  = 'Les mots de passe ne correspondent pas';
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success('Compte créé avec succès !');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur lors de la création du compte');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--elvyra-bg)', padding: 'var(--space-4)',
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <Logo size="lg" showText={true} />
          <p style={{ fontSize: 'var(--text-xs)', color: 'var(--elvyra-text-muted)', marginTop: 8 }}>
            DEKANI SOFTWARE
          </p>
        </div>
        <div className="card">
          <h2 style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-bold)', marginBottom: 8 }}>
            Créer un compte
          </h2>
          <p style={{ color: 'var(--elvyra-text-secondary)', marginBottom: 32, fontSize: 'var(--text-sm)' }}>
            Commencez gratuitement — plan FREE inclus
          </p>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <Input
              label="Nom complet" required
              placeholder="Votre nom"
              value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
              error={errors.name}
            />
            <Input
              label="Email" type="email" required
              placeholder="vous@exemple.com"
              value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              error={errors.email}
            />
            <Input
              label="Mot de passe" type="password" required
              placeholder="Min 8 caractères"
              value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              error={errors.password}
            />
            <Input
              label="Confirmer le mot de passe" type="password" required
              placeholder="Répétez le mot de passe"
              value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
              error={errors.confirm}
            />
            <Button type="submit" loading={loading} style={{ width: '100%', marginTop: 8 }}>
              Créer mon compte
            </Button>
          </form>
          <p style={{ textAlign: 'center', marginTop: 24, fontSize: 'var(--text-sm)', color: 'var(--elvyra-text-secondary)' }}>
            Déjà un compte ?{' '}
            <Link to="/login" style={{ color: 'var(--elvyra-accent)' }}>Se connecter</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
